import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from '../../../../InputComponent';
import { LanguageFactory } from '../../../../../factories';
import { useLanguage } from '../../../../../store/languageContext';
import SearchDebounceBar from '../../../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../../../factories/propertySearchs';
import { Button, Card, Table } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import moment from 'moment';
import { sortHelper } from '../../../../../helpers/misc/sortHelper'

interface PropsType {
    changeTab: void | any,
    setFeesDetails: void | any,
    isEditable: void | any,
    detailData: any,
}

const Fees = (props: PropsType) => {

    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [total, setTotal] = useState(dataSource.length)
    const [data, setData] = useState<any[]>([]);
    //const [chargeName, setChargeName] = useState()



    const columns = [
        {
            title: '',
            key: 'index',
            render: (text: string, record: [], index: number) => index += 1,
            width: '40px'
        },
        {
            title: 'Policy Name ',
            dataIndex: 'policycode',
            key: 'policycode',
            sorter: (a: [], b: []) => sortHelper(a, b, 'policycode'),
            showSorterTooltip: false
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            sorter: (a: [], b: []) => sortHelper(a, b, 'type'),
            showSorterTooltip: false
        },
        {
            title: 'Start Date',
            dataIndex: 'startdate',
            key: 'startdate',
            sorter: (a: [], b: []) => sortHelper(a, b, 'startdate'),
            showSorterTooltip: false
        },
        {
            title: 'End Date',
            dataIndex: 'enddate',
            key: 'enddate',
            sorter: (a: [], b: []) => sortHelper(a, b, 'enddate'),
            showSorterTooltip: false
        },
        {
            title: 'Charge Type',
            dataIndex: 'chargetype',
            key: 'chargetype',
            sorter: (a: [], b: []) => sortHelper(a, b, 'chargetype'),
            showSorterTooltip: false
        },
    ]

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    useEffect(() => {
        let dataSource = props?.detailData?.policies?.feepolicy || []
        dataSource.map((item: any, index: number) => item.key = index)
        setDataSource(dataSource);
        setData(dataSource);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])

    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                itemData[col['dataIndex']] = item[col.dataIndex]?.toLowerCase() || '';
            })
            return JSON.stringify(Object.values(item))
                .toLocaleLowerCase()
                .indexOf(query.toLocaleLowerCase()) > -1;

        })

        setDataSource(filterData);
    }
    useEffect(() => {
        setTotal(dataSource.length)
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [dataSource])
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])
    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }}>
                <Grid container spacing={0} className="containerSpacing py-0">
                    <Grid item xs={12} className="p-0">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 'bold', fontSize: 14, color: '#333' }}>Fees</div>
                            <div><Button className="db-add-btn" onClick={() => { props.isEditable(); props.changeTab('FeesAdd') }}>Add</Button></div>
                        </div>
                    </Grid>
                    <Grid item xs={4} className="pb-0 px-0 my-0">
                        <ImputComponent
                            className='SearchBar'
                            label='Search'
                            labelShrink={true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            placeholder={lang.translate(language, 'fees_search_placeholder')}
                            endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                        />
                        <div className="recentlySearchs">
                            <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="p-0">
                        <Table
                            columns={columns}
                            dataSource={
                                dataSource
                            }
                            pagination={{
                                size: "small",
                                total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                                defaultPageSize: 10,
                                defaultCurrent: 1,
                                onChange: (page, pageSize) => {
                                    console.log(page + '===' + pageSize)
                                }
                            }}
                            onRow={record => {
                                return {
                                    onClick: () => {
                                        // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                        record.dateRange = [record.startdate ? moment(record.startdate) : null, record.enddate ? moment(record.enddate) : null]
                                        props.setFeesDetails(record)
                                        props.changeTab('FeesDetails')
                                    },
                                };
                            }}
                        />
                    </Grid>
                </Grid>
            </Card>
        </PageContainer>
    )
}

export default Fees;

